import React, { Suspense } from 'react';

import { useQueryState } from '../../../hooks/useQueryState';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import NewLayout from '../../components/NewLayout/NewLayout';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../../../context/useAuthContext';
import Loading from '../../../components/Loading';
import CreateLocation from './components/CreateLocation';
import HoneLocationsProvider from '../../../components/HoneLocations';
import { IconAdmin, IconNavAdmin } from '../../../components/Icons';
import { LocalErrorBoundary } from 'components/ErrorBoundary';
import UsersAdmin from './UsersAdmin';
import Footer from 'presentation/components/Footer/Footer';

const tabs = [
  {
    name: 'Users',
    component: <UsersAdmin />,
  },
  {
    name: 'Location',
    component: <CreateLocation />,
  },
];

function AdminPage() {
  const [activeTab] = useQueryState('activetab', 'Users');
  const navigateTo = useNavigate();
  const { currentLocation } = useAuthContext();

  const handleClickTab = (tabName: string) => {
    navigateTo(`/app/location/${currentLocation?.locationId}/admin?activetab=${tabName}`);
  };
  const idxActiveTab = tabs.findIndex(tab => tab.name === activeTab);

  return (
    <Tabs selectedTabClassName="react-tabs-tab-selected" selectedIndex={Number(idxActiveTab)}>
      <NewLayout
        icon={IconNavAdmin}
        pageTitle="Admin"
        className="bookkeeper"
        chartArea={
          <TabList>
            {tabs.map((tab, idx: number) => (
              <Tab
                selected={idx === idxActiveTab}
                className="react-tabs-tab"
                onClick={() => handleClickTab(tab.name)}
                key={`${tab.name}_${idx}`}
              >
                {tab.name}
              </Tab>
            ))}
          </TabList>
        }
      >
        <div className="bookkeeper-layout">
          <div className="Layout">
            <Suspense fallback={<Loading />}>
              <main className="Layout-main">
                <div className="Layout-content">
                  <HoneLocationsProvider>
                    {tabs.map((tab, idx: number) => (
                      <TabPanel key={`${tab.name}_${idx}`}>{tab.component}</TabPanel>
                    ))}
                  </HoneLocationsProvider>
                </div>
                <Footer />
              </main>
            </Suspense>
          </div>
        </div>
      </NewLayout>
    </Tabs>
  );
}

const AdminPageWrapped = () => (
  <LocalErrorBoundary>
    <AdminPage />
  </LocalErrorBoundary>
);

export default AdminPageWrapped;
